import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Button } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const CustomMassiveActions = function CustomMassiveActions({
  close,
  goBack,
  currentPage,
}) {
  const intl = useIntl();

  return (
    <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
      <Button variant="text" onClick={currentPage === 0 ? close : goBack}>
        {currentPage === 0 ? intl.messages.CLOSE : intl.messages.BACK}
      </Button>
      <Button endIcon={currentPage === 1 && <SendIcon />} type="submit">
        {intl.messages.CONFIRM}
      </Button>
    </div>
  );
};

CustomMassiveActions.propTypes = {
  close: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
};

export default CustomMassiveActions;
